import { useMemo } from "react";
import { useSessionData } from "./session-data";

export type RtkSessionArgs = {
  business_id: string | null;
  device_token: string | null;
  session_id: string | null;
};

export function toRtkSessionArgs(
  business_id: string | null,
  device_token: string | null,
  session_id: string | null
): RtkSessionArgs {
  return {
    business_id: business_id ?? null,
    device_token: device_token ?? "",
    session_id: session_id ?? "",
  };
}

export function isRtkSessionReady(args: RtkSessionArgs): boolean {
  return Boolean(args.business_id && args.device_token && args.session_id);
}

export function useRtkSessionArgs(): { args: RtkSessionArgs; skip: boolean } {
  const { business_id, device_token, session_id } = useSessionData();
  return useMemo(() => {
    const args = toRtkSessionArgs(business_id, device_token, session_id);
    return { args, skip: !isRtkSessionReady(args) };
  }, [business_id, device_token, session_id]);
}
